export const environment = {
  production: false,
  apiUrl: 'https://api.perfection.pereborstudio.com',
  landingUrl: 'https://layout.perfection.pereborstudio.com',
  recaptchaSiteKey: '6LddhgogAAAAAErZkc1oexAZgIRcdzuJ-bdnxKCE',
};
